import axios from "axios";
import config from "../../config";
import Storage from "../../helpers/Storage";
import snippets from "../../helpers/snippets";
import {default as _} from "../../helpers/Translate"

class Api {
  url = config.baseUrl;
  language = null;
  _token = null;

  constructor() {}

  setToken() {
    if (Storage.isLogin()) {
      this._token = Storage.getUserInfo().token;
    }
  }

  setLanguage(){
    this.language = Storage.getLanguage() === "en" ? "en-US,en;q=0.9" : "fa-IR,fa;";
  }

  setPoint(url) {
    this.url = config.baseUrl + url;
  }

  send(type, data = null, responseType = null) {
    this.setToken();
    this.setLanguage()
    let headers = {"Accept-Language": this.language};
    if (this._token) {
      Object.assign(headers, { ticket: this._token });
    }
    const paramsSerializer = (params) => {
      return Object.entries(params).filter(([, value]) => !snippets.isObjectEmpty(value))
            .map(([key, value]) => typeof value !== "object" ? `${encodeURIComponent(key)}=${encodeURIComponent(_.localNumber(value, "en"))}`: value.map(item => `${encodeURIComponent(key)}[]=${_.localNumber(item, "en")}`))
            .join('&').replaceAll(",","&")
    };

    switch (type) {
      case "get":
        return axios.get(this.url, {
          headers: headers,
          params: data,
          responseType: responseType,
          paramsSerializer: paramsSerializer
        });
      case "post":
        return axios.post(this.url, data, { headers: headers });
      case "put":
        return axios.put(this.url, data, { headers: headers });
      case "delete":
        return axios.delete(this.url, { data: data, headers: headers });
    }
  }
}

export default Api;
